import * as React from 'react';

import { cn } from '@/lib/utils';
import { Heading } from '@/components/ui/heading';

export interface EmptyStateProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  variant?: 'default' | 'contrast';
  className?: string;
  iconClassName?: string;
  titleClassName?: string;
  descriptionClassName?: string;
}

/**
 * EmptyState mostra titolo, descrizione e CTA opzionale in assenza di dati.
 *
 * @example
 * <EmptyState
 *   title="Nessun diario completato"
 *   description="Quando completi un diario, lo troverai qui."
 * />
 */
export function EmptyState({
  title,
  description,
  icon,
  action,
  variant = 'default',
  className,
  iconClassName,
  titleClassName,
  descriptionClassName,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 py-6 text-center text-foreground',
        variant === 'contrast' && 'rounded-2xl border border-border/70 bg-muted/40 px-6',
        className,
      )}
    >
      {icon ? (
        <div className={cn('flex items-center justify-center text-muted-foreground', iconClassName)}>
          {icon}
        </div>
      ) : null}
      <Heading level={4} align="center" className={cn(titleClassName)}>
        {title}
      </Heading>
      {description ? (
        <p className={cn('text-sm text-muted-foreground', descriptionClassName)}>{description}</p>
      ) : null}
      {action ? <div className="pt-2">{action}</div> : null}
    </div>
  );
}
